import { getCurrentLanguage } from "utils/src/getCurrentLanguage";
import { apiClient } from "../../../../apps/crossword-maker/src/shared/apiClient";

export type TAddCategoryToWord = (
	word: string,
	category: string,
) => Promise<any>;

export const addCategoryToWordByValues: TAddCategoryToWord = async (word, category) => {
	const language = getCurrentLanguage();

	const response = await apiClient().post(
		`/rest/${language}/crossword-book/word-category/by-values`,
		{
			wordValue: word,
			categoryValue: category,
		}
	);
	return response.data;
};
